module.exports = __webpack_public_path__ + "img/classroom_storyteller_514x500.3cab5ce0.jpg";